import { StoreState } from "@type/models/store";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { REACT_IMAGE_URL } from "../../../constants";
import { ReleaseState } from "@type/models/store";

interface Country {
  id: string;
  title: string;
  code_alpha2: string;
  img_flag: number;
}

const countryIds = [
  "AR",
  "AW",
  "BO",
  "BR",
  "CL",
  "CO",
  "EC",
  "FK",
  "GF",
  "GY",
  "PY",
  "PE",
  "VC",
  "GS",
  "SR",
  "TT",
  "UY",
  "VE",
];

interface SouthAmericaTerritoriesProps {
  countriesCheck: any;
  onSetSelectedTerritories: (
    continent: string,
    selectedCountries: string[]
  ) => void;
}

const SouthAmericaTerritories: React.FC<SouthAmericaTerritoriesProps> = ({
  countriesCheck,
  onSetSelectedTerritories,
}) => {
  const [selectedCountries, setSelectedCountries] = useState<string[]>([]);
  const territories = useSelector(
    (state: StoreState) => state.suggestion.territories
  );
  const { countryInfo } = useSelector(
    (state: ReleaseState) => state.releaseInfo.releaseInfo
  );
  const filteredTerritories = territories.filter((country: any) =>
    countryIds.includes(country.code_alpha2)
  );

  const handleCountrySelection = (countryId: string) => {
    if (selectedCountries.includes(countryId)) {
      setSelectedCountries(selectedCountries.filter((id) => id !== countryId));
    } else {
      setSelectedCountries([...selectedCountries, countryId]);
    }
  };

  const handleCheckAll = () => {
    const allCountryIds = filteredTerritories.map((country) => country.id);
    setSelectedCountries(allCountryIds);
  };

  const handleUncheckAll = () => {
    setSelectedCountries([]);
  };

  useEffect(() => {
    if (typeof countriesCheck === "string") handleCheckAll();
    else handleUncheckAll();
  }, [countriesCheck]);

  useEffect(() => {
    onSetSelectedTerritories("southAmerica", selectedCountries);
  }, [selectedCountries]);

  useEffect(() => {
    const storedTerritoriesString = localStorage.getItem("selectedTerritories");
    if (storedTerritoriesString) {
      const storedTerritories = JSON.parse(storedTerritoriesString);
      if (storedTerritories && storedTerritories.southAmerica) {
        setSelectedCountries(storedTerritories.southAmerica);
      }
    }
  }, []);

  useEffect(() => {
    if (countryInfo?.countryId.length > 0) {
      const selectedTerritories = countryInfo.countryId
        .map((selectedCountry: any) =>
          territories.find(
            (territory) =>
              selectedCountry.country_id === territory.id &&
              countryIds.includes(territory.code_alpha2)
          )
        )
        .filter(Boolean);

      if (selectedTerritories.length > 0) {
        setSelectedCountries(
          selectedTerritories.map((territory: any) => territory.id)
        );
      }
    }
  }, [countryInfo?.countryId]);

  return (
    <div className="col-12 col-sm-6 col-md-4 col-lg-3">
      <div className="subsection-title my-1em">
        <span style={{ fontSize: "2rem" }}>South America</span>
        <div className="flex font-1rem my-2">
          <a className="flex mx-1" href="#" onClick={handleCheckAll}>
            Check all
          </a>{" "}
          |{" "}
          <a className="flex mx-1" href="#" onClick={handleUncheckAll}>
            Uncheck all
          </a>
        </div>
      </div>

      {filteredTerritories.map((country: Country) => (
        <div
          key={country.id}
          className="custom-control custom-checkbox round-checkbox mb-2 relative block min-h-6 pl-6 border-gray-400"
        >
          <label className="flex items-center">
            <div className="w-6 h-6 mr-2  rounded-full flex-shrink-0">
              <input
                type="checkbox"
                className="hidden"
                checked={selectedCountries.includes(country.id)}
                onChange={() => handleCountrySelection(country.id)}
              />
              <div
                className={`w-3 h-3 ${
                  selectedCountries.includes(country.id)
                    ? "bg-blue-500"
                    : "bg-transparent"
                } rounded-full z-2`}
              ></div>
            </div>
            <img
              src={`${REACT_IMAGE_URL}/static/images/flags/${country.code_alpha2.toLocaleLowerCase()}.svg`}
              className="w-6 h-6 align-middle border-none"
              alt="Flag"
              style={{
                width: "5% !important",
                height: "1rem",
                margin: "0px 5px",
              }}
            />
            <span className="align-middle">{country.title}</span>
          </label>
        </div>
      ))}
    </div>
  );
};

export default SouthAmericaTerritories;
